import { LOGOUT_PAGE_ROUTE } from '@constants/routes';
import { LoadingSpinner } from '@conversed/ui/src/components/spinner/LoadingSpinner';
import { getInitialLoginCredentials } from '@store/initialState';
import type React from 'react';
import { useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router';
import { Slide, ToastContainer } from 'react-toastify';
import { useMainSelector } from '../hooks/useMainSelector';
import ScrollToTop from './common/ScrollToTop';
import { AuthenticatedLayout } from './layouts/AuthenticatedLayout';
import { ModalContainer } from './layouts/modal/ModalContainer';
import { UnauthenticatedLayout } from './layouts/UnauthenticatedLayout';

export const Main: React.FC = () => {
  const {
    login: { isLoggedIn },
    ui: { isLoading },
  } = useMainSelector();
  const { isLoggedIn: isLoggedInByLocalStorage } = getInitialLoginCredentials();
  const navigate = useNavigate();

  useEffect(() => {
    // If the user is logged in based on the state value but manually removed the token from local storage, redirect them to the logout page.
    if (isLoggedIn !== isLoggedInByLocalStorage) {
      navigate(LOGOUT_PAGE_ROUTE);
    }
  }, [isLoggedIn, isLoggedInByLocalStorage, navigate]);

  return (
    <>
      <ScrollToTop />
      <LoadingSpinner visible={isLoading} />
      <Routes>
        <Route
          path='*'
          element={
            isLoggedIn ? <AuthenticatedLayout /> : <UnauthenticatedLayout />
          }
        />
      </Routes>
      <ToastContainer
        hideProgressBar={true}
        transition={Slide}
        autoClose={3000}
      />
      <ModalContainer />
    </>
  );
};
